// src/pages/Signup.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';   // ← Link 사용 권장
import api from '../api';
import styles from './Signup.module.css';

export default function Signup() {
  const [form, setForm] = useState({
    username: '',
    password: '',
    name: '',
    position: '',
    mobile: '',
    direct_phone: '',   // ✅ 통일: direct_phone (snake_case)
    email: ''
  });
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value })); // name과 state 키 1:1
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    const { username, password, name, email } = form;
    if (!username || !password || !name || !email) {
      return setErrorMsg('아이디, 비밀번호, 이름, 이메일은 필수입니다.');
    }

    try {
      await api.post('/users/signup/', {
        username:     form.username.trim(),
        password:     form.password,
        name:         form.name.trim(),
        position:     form.position.trim(),
        mobile:       form.mobile.trim(),
        direct_phone: form.direct_phone.trim(),   // ✅ 통일: 전송 키도 direct_phone
        email:        form.email.trim()
      });

      alert('회원가입 신청이 완료되었습니다.\n관리자 승인을 기다려주세요.');
      navigate('/login', { replace: true });
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        '서버 오류가 발생했습니다.';
      setErrorMsg(msg);
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.siteHeader}>
        <Link to="/" className={styles.ciLogo}>금천일자리주식회사</Link>
      </header>

      <div className={styles.signupContainer}>
        <div className={styles.signupBox}>
          <h2>회원가입</h2>
          <p className={styles.description}>
            금천일자리주식회사 내부망 ERP 프로그램입니다.
          </p>

          <form onSubmit={handleSubmit}>
            <input name="username"  value={form.username}  onChange={handleChange} placeholder="아이디 (영문)" required />
            <input type="password" name="password"  value={form.password}  onChange={handleChange} placeholder="비밀번호(영문/숫자 8자 이상)" required />
            <input name="name"      value={form.name}      onChange={handleChange} placeholder="이름" required />
            <input name="position"  value={form.position}  onChange={handleChange} placeholder="직위(대표, 팀장…)" />
            <input name="mobile"    value={form.mobile}    onChange={handleChange} placeholder="휴대전화(010-0000-0000)" />
            <input
              name="direct_phone"                         // ✅ 통일: input name
              value={form.direct_phone}                   // ✅ 통일: state 키
              onChange={handleChange}
              placeholder="직통전화(070-0000-0000)"
            />
            <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="이메일" required />

            <button type="submit" className={styles.submitBtn}>회원가입</button>
            {errorMsg && <p className={styles.error}>{errorMsg}</p>}
          </form>

          <div className={styles.links}>
            <Link to="/login">로그인 화면으로 돌아가기</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
